
import { i18nText } from '@/locales';
import { RouterNameEnum } from "@/router/router.types";
import { RouterProperties } from "@/router/routerProperties";
export const LoyaltyRoutes = [
    {
        path: "/loyalty",
        redirect: "/loyalty/index",
        component: (): any => import("@/UI/layouts/MainLayout.vue"),
        meta: {
            alias: RouterNameEnum.LoyaltyCert,
            auth: true,
        },
        children: [
            {
                path: "index",
                component: (): any => import("@/UI/pages/loyalty/pages/certificates/Tabs.vue"),
                name: RouterNameEnum.Loyalty,
                meta: {
                    alias: RouterNameEnum.LoyaltyCert,
                },
                children: [
                    {
                        path: "loyaltyCert/:Studio",
                        meta: {
                            alias: RouterNameEnum.LoyaltyCert,
                            title: i18nText("Лояльность | Сертификаты - EPILIER"),
                            breadcrumb: [
                                { name: i18nText("Сертификаты"), support: ["studioselect"] },
                            ],
                            props: {
                                source: {
                                    root: "loyaltyCert",
                                    name: "loyaltyCert",
                                    items: "loyaltyCerts",
                                    item: "loyaltyCert",

                                    routePage: RouterNameEnum.LoyaltyCertPage,
                                },
                            },
                        },

                        name: RouterNameEnum.LoyaltyCert,
                        component: (): any => import("@/UI/pages/loyalty/pages/certificates/Certificates.vue"),
                    },
                    {
                        path: "/loyaltyCert/:Studio/:page/:total/:filter",
                        meta: {
                            alias: RouterNameEnum.LoyaltyCert,
                            title: i18nText("Лояльность | Сертификаты - EPILIER"),
                            breadcrumb: [
                                { name: i18nText("Сертификаты"), support: ["studioselect"] },
                            ],
                            props: {
                                source: {
                                    root: "loyaltyCert",
                                    name: "loyaltyCert",
                                    items: "loyaltyCerts",
                                    item: "loyaltyCert",

                                    routePage: RouterNameEnum.LoyaltyCertPage,
                                },
                            },
                        },

                        name: RouterNameEnum.LoyaltyCertPage,
                        component: (): any => import("@/UI/pages/loyalty/pages/certificates/Certificates.vue"),
                    },
                    {
                        path: "loyaltyCertType/:Studio",
                        meta: {
                            alias: RouterNameEnum.LoyaltyCert,
                            title: i18nText("Лояльность | Типы сертификатов - EPILIER"),
                            breadcrumb: [
                                { name: i18nText("Типы сертификатов"), support: ["studioselect"] }
                            ],
                            props: {
                                source: {
                                    root: "loyaltyCertType",
                                    name: "loyaltyCertType",
                                    items: "loyaltyCertTypes",
                                    item: "loyaltyCertType",

                                    routePage: RouterNameEnum.LoyaltyCertTypePage,
                                },
                            },
                        },
                        name: RouterNameEnum.LoyaltyCertType,
                        component: (): any => import("@/UI/pages/loyalty/pages/certificates/CertificatesType.vue"),
                    },
                    {
                        path: "loyaltyCertType/:Studio/:page/:total/:filter",
                        meta: {
                            alias: RouterNameEnum.LoyaltyCert,
                            title: i18nText("Лояльность | Типы сертификатов - EPILIER"),
                            breadcrumb: [
                                { name: i18nText("Типы сертификатов"), support: ["studioselect"] }
                            ],
                            props: {
                                source: {
                                    root: "loyaltyCertType",
                                    name: "loyaltyCertType",
                                    items: "loyaltyCertTypes",
                                    item: "loyaltyCertType",
                                    routePage: RouterNameEnum.LoyaltyCertTypePage,
                                },
                            },
                        },
                        name: RouterNameEnum.LoyaltyCertTypePage,

                        component: (): any => import("@/UI/pages/loyalty/pages/certificates/CertificatesType.vue"),
                    },
                ],
            },
            {
                path: "loyaltyCertType/:Studio/Add",
                meta: {
                    alias: RouterNameEnum.LoyaltyCert,
                    title: i18nText("Лояльность | Типы сертификатов | Добавить сертификат "),
                    breadcrumb: [
                        { name: i18nText("Типы сертификатов"), link: "LoyaltyCertType" },
                        { name: i18nText("Создание типа сертификата"), support: ["submitButton", "closeButton"] }
                    ],
                },
                name: RouterNameEnum.LoyaltyCertTypeAdd,
                component: (): any => import("@/UI/pages/loyalty/pages/certificates/Create.vue"),
                props: { mode: 0 },
            },
            {
                path: "loyaltyCertType/:Studio/Get/:id",
                meta: {
                    alias: RouterNameEnum.LoyaltyCert,
                    title: i18nText("Лояльность | Типы сертификатов |Редактировать сертификат "),
                    breadcrumb: [
                        { name: i18nText("Типы сертификатов"), link: "LoyaltyCertType" },
                        { name: i18nText("Редактирование типа сертификата"), support: ["deleteButton", "submitButton", "closeButton"] },
                    ],
                },
                name: RouterNameEnum.LoyaltyCertTypeGet,
                component: (): any => import("@/UI/pages/loyalty/pages/certificates/Create.vue"),
                props: { mode: 1 },
            },




            {
                path: "loyaltySubscriptionCard/:id",
                meta: {
                    alias: RouterNameEnum.LoyaltySubscription,
                    breadcrumb: [
                        { name: i18nText("Абонементы"), link: "LoyaltySubscription" , support: ["studioselect"] },
                        { name: i18nText("Карточка абонемента") }
                    ],
                },
                name: RouterNameEnum.LoyaltySubscriptionCard,
                component: (): any => import("@/UI/pages/loyalty/pages/subscriptions/SubscriptionCard.vue"),
            },
            {
                path: "index",
                component: (): any => import("@/UI/pages/loyalty/pages/subscriptions/Tabs.vue"),
                name: RouterNameEnum.LoyaltySubscriptionIndex,
                meta: {
                    alias: RouterNameEnum.LoyaltySubscription,
                },
                children: [
                    {
                        path: "loyaltySubscription/:Studio?",
                        meta: {
                            alias: RouterNameEnum.LoyaltySubscription,
                            title: i18nText("Лояльность | Абонемент - EPILIER"),
                            breadcrumb: [
                                { name: i18nText("Абонемент"), support: ["studioselect"] },
                            ],
                            props: {
                                source: {
                                    root: "loyaltySubscription",
                                    name: "loyaltySubscription",
                                    items: "loyaltySubscriptions",
                                    item: "loyaltySubscription",

                                    routePage: RouterNameEnum.LoyaltySubscriptionPage,
                                },
                            },
                        },
                        props: { source: RouterProperties.loyaltySubscription },
                        name: RouterNameEnum.LoyaltySubscription,
                        component: (): any => import("@/UI/pages/loyalty/pages/subscriptions/Subscriptions.vue"),
                    },
                    {
                        path: "loyaltySubscription/:Studio/:page/:total/:filter",
                        meta: {
                            alias: RouterNameEnum.LoyaltySubscription,
                            title: i18nText("Лояльность | Абонемент - EPILIER"),
                            breadcrumb: [
                                { name: i18nText("Абонемент"), support: ["studioselect"] },
                            ],
                            props: {
                                source: {
                                    root: "loyaltySubscription",
                                    name: "loyaltySubscription",
                                    items: "loyaltySubscriptions",
                                    item: "loyaltySubscription",

                                    routePage: RouterNameEnum.LoyaltySubscriptionPage,
                                },
                            },
                        },
                        props: { source: RouterProperties.loyaltySubscription },
                        name: RouterNameEnum.LoyaltySubscriptionPage,
                        component: (): any => import("@/UI/pages/loyalty/pages/subscriptions/Subscriptions.vue"),
                    },//LoyaltySubscriptionType
                    {
                        path: "loyaltySubscriptionType/:Studio?",
                        meta: {
                            alias: RouterNameEnum.LoyaltySubscription,
                            title: i18nText("Лояльность | Типы абонементов - EPILIER"),
                            breadcrumb: [
                                { name: i18nText("Типы абонементов"), support: ["studioselect"] }
                            ],
                            props: {
                                source: {
                                    root: "loyaltySubscriptionType",
                                    name: "loyaltySubscriptionType",
                                    items: "loyaltySubscriptionTypes",
                                    item: "loyaltySubscriptionType",

                                    routePage: RouterNameEnum.LoyaltySubscriptionTypePage,
                                },
                            },
                        },
                        name: RouterNameEnum.LoyaltySubscriptionType,
                        props: { source: RouterProperties.loyaltySubscriptionType },
                        component: (): any => import("@/UI/pages/loyalty/pages/subscriptions/SubscriptionsType.vue"),
                    },
                    {
                        path: "loyaltySubscriptionType/:Studio/:page/:total/:filter",
                        meta: {
                            alias: RouterNameEnum.LoyaltySubscription,
                            title: i18nText("Лояльность | Типы абонементов - EPILIER"),
                            breadcrumb: [
                                { name: i18nText("Типы абонементов"), support: ["studioselect"] }
                            ],
                            props: {
                                source: {
                                    root: "loyaltySubscriptionType",
                                    name: "loyaltySubscriptionType",
                                    items: "loyaltySubscriptionTypes",
                                    item: "loyaltySubscriptionType",

                                    routePage: RouterNameEnum.LoyaltySubscriptionTypePage,
                                },
                            },
                        },
                        name: RouterNameEnum.LoyaltySubscriptionTypePage,
                        props: { source: RouterProperties.loyaltySubscriptionType },
                        component: (): any => import("@/UI/pages/loyalty/pages/subscriptions/SubscriptionsType.vue"),
                    },
                ],
            },
            {
                path: "loyaltyBonus",
                meta: {
                    alias: RouterNameEnum.LoyaltyBonus,
                    title: i18nText("Лояльность | Бонусная программа - EPILIER"),
                    breadcrumb: [{ name: i18nText("Бонусная программа") }],
                },
                name: RouterNameEnum.LoyaltyBonus,
                component: (): any => import("@/UI/pages/loyalty/pages/bonus/Bonus.vue"),
            },
            {
                path: "loyaltyBonusType",
                meta: {
                    alias: RouterNameEnum.LoyaltyBonus,
                    title: i18nText("Лояльность | Типы бонусных программ - EPILIER"),
                    breadcrumb: [{ name: i18nText("Типы бонусных программ") }],
                },
                name: RouterNameEnum.LoyaltyBonusType,
                component: (): any => import("@/UI/pages/loyalty/pages/bonus/BonusType.vue"),
            },
            {
                path: "loyaltyStock",
                meta: {
                    alias: RouterNameEnum.LoyaltyStock,
                    title: i18nText("Лояльность | Акции - EPILIER"),
                    breadcrumb: [{ name: i18nText("Акции") }],
                },
                name: RouterNameEnum.LoyaltyStock,
                component: (): any => import("@/UI/pages/loyalty/pages/stock/Stock.vue"),
            },
        ],
    },
];
